import { ErrorMessage, Field as Fieldmik, FieldArray } from 'formik';
import React, { useEffect, useState } from 'react';
import {
    Button, Dropdown, Grid,
    Header, Icon, Modal, Table
} from 'semantic-ui-react';

import { MyNormalInput } from '../formikInput/input';
import ProductSKUDropdown from '../dropdowns/productSKUDropdown';

const AddProduct = ({ handleChange, billmode, masterState, vendorStateId, isGstApplicable, msgToDisplay }) => {
    const [productData, setProductData] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [productDetail, setProductDetail] = useState([]);
    const [isUpdated, setisUpdated] = useState(false);

    let getProductData = childData => {
        setProductData(childData);
    };
    useEffect(() => {
         getProductData = childData => {
            setProductData(childData);
        };
    },[masterState, vendorStateId])

    const valueChangeDiscount = (object) => {
        setisUpdated(object.discountType);
        let tempAmount;
        if (object.discount > 0 && object.discountType == 1) {
            let finalRate = +object.rate * +object.quantity;
            tempAmount = +finalRate - +object.discount;
            object.productAmount = tempAmount;
        } else {
            let finalRate = +object.rate * +object.quantity;
            tempAmount = +finalRate - (+finalRate * +object.discount / 100);
            object.productAmount = tempAmount;
        }
        object.iGst = isGstApplicable ? +object.iGstPercent / 100 * +tempAmount : 0;
        object.cGst = isGstApplicable ? +object.cGstPercent / 100 * +tempAmount : 0;
        object.sGst = isGstApplicable ? +object.sGstPercent / 100 * +tempAmount : 0;

        object.amount = +tempAmount + +object.iGst + +object.cGst + +object.sGst;
    };

    return (
        <div className="ui form tiny">
            <FieldArray
                key={isUpdated}
                name="productDetails">
                {({ push, remove, replace, form }) => {

                    const { values } = form
                    const { productDetails } = values

                    if (billmode) {
                        values.manualSoAddedTotal = parseFloat(productDetails.reduce((total, obj) => obj.amount + total, 0)).toFixed(2)
                        values.finalAmount = +values.activeSoAddedTotal + +values.manualSoAddedTotal
                    } else {
                        values.finalAmount = parseFloat(productDetails.reduce((total, obj) => obj.amount + total, 0)).toFixed(2)
                    }

                    values.productAmountTotal = parseFloat(productDetails.reduce((total, obj) => obj.productAmount + total, 0)).toFixed(2)

                    let productSelectedArray = []

                    productDetails.map((product, index) => {
                        let temp = {}
                        temp.productName = product.productName

                        productSelectedArray[index] = temp
                    })

                    const handleUpdateProduct = (e, data, index, object) => {
                        setisUpdated(true);
                        const { setFieldValue } = form
                        const addedProductObject = productData.filter(e => {
                            return e.psId === data.value
                        })
                        if (addedProductObject.length) {
                            setFieldValue(data.name, data.value).then(() => {
                                replace(index, {
                                    productName: data.value,
                                    productCode: addedProductObject[0]?.psCode || "",
                                    hsnCode: addedProductObject[0]?.HSNCode || "",
                                    sacCode: addedProductObject[0]?.SACCode || "",
                                    quantity: object.quantity,
                                    discountType: object.discountType,
                                    discount: "",
                                    rate: addedProductObject[0]?.sellingPrice || 0,
                                    iGstPercent: vendorStateId === masterState ? "" : addedProductObject[0]?.gstPercentage,
                                    cGstPercent: vendorStateId === masterState ? addedProductObject[0]?.gstPercentage / 2 : 0,
                                    sGstPercent: vendorStateId === masterState ? addedProductObject[0]?.gstPercentage / 2 : 0,
                                })
                            })
                        }
                    };

                    return (
                        <>
                            <Table unstackable size="large" compact="very" className="w3-small">
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell className="w3-white" colSpan="8">  <label className="labelName w3-text-blue">Product/Service Details</label></Table.HeaderCell>
                                        {
                                            msgToDisplay ?
                                                <Table.Cell className="w3-white" colSpan="8">
                                                    <h2 style={{ fontSize: '12px', color: '#1678c2' }} className='mt-2'>Reason:  {msgToDisplay}</h2>
                                                </Table.Cell>
                                                : null
                                        }
                                        {/* {
                                            values.is_gst_applicable === 1 && values.GSTExemptedReasonName === 'RCM' ?
                                                <Table.Cell className="w3-white" colSpan="8">
                                                    <h2 style={{ fontSize: '12px', color: '#1678c2' }} className='mt-2'>GST Charge Mechanism : RCM</h2>
                                                </Table.Cell>
                                                : null
                                        } */}
                                    </Table.Row>
                                    <Table.Row >
                                        <Table.HeaderCell className="labelName p-bold-600">Product Details</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">HSN/SAC Code</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Quantity</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Rate</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Discount</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">IGST%</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">IGST(₹)</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">CGST</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">CGST(₹)</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">SGST</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">SGST(₹)</Table.HeaderCell>
                                        <Table.HeaderCell className="labelName p-bold-600">Amount</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="right" className="labelName p-bold-600">Delete</Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {productDetails.map((object, index) => {
                                        const discountOptions = [
                                            { key: '1', text: '₹', value: '1' },
                                            { key: '2', text: '%', value: '2' },
                                        ];
                                        let tempAmount = '';
                                        if (object.discount > 0 && object.discountType == 1) {
                                            let finalRate = +object.rate * +object.quantity;
                                            tempAmount = +finalRate - +object.discount;
                                            object.productAmount = tempAmount;
                                        } else {
                                            let finalRate = +object.rate * +object.quantity;
                                            tempAmount = +finalRate - (+finalRate * +object.discount / 100);
                                            object.productAmount = tempAmount;
                                        }

                                        object.iGst = isGstApplicable ? +object.iGstPercent / 100 * +tempAmount : 0;
                                        object.cGst = isGstApplicable ? +object.cGstPercent / 100 * +tempAmount : 0;
                                        object.sGst = isGstApplicable ? +object.sGstPercent / 100 * +tempAmount : 0;

                                        object.amount = +tempAmount + +object.iGst + +object.cGst + +object.sGst;

                                        return (
                                            <Table.Row verticalAlign="middle" key={index}>
                                                <React.Fragment>
                                                    <Table.Cell className='row'>
                                                        <Fieldmik
                                                            component={ProductSKUDropdown}
                                                            handleUpdateProduct={handleUpdateProduct}
                                                            productIndex={index}
                                                            productObject={object}
                                                            getProductData={getProductData}
                                                            placeholder={object.productName ? object.productName : ''}
                                                            name={`productDetails[${index}].productName`}
                                                            className='ml-3'
                                                            style={{ width: '160px' }}
                                                            value={object.productName ? object.productName : ''}
                                                            selectedProductEdit={object.productName}
                                                            productSelectedArray={productSelectedArray}
                                                        />

                                                        {/* {
                                                            object?.product_details?.length ?
                                                                <i className="fa fa-eye mt-1 ml-1" onClick={() => { setProductDetail(object.product_details); setModalShow(true) }} style={{ fontSize: '18px', color: '#1678c2' }}
                                                                    aria-hidden="true" />
                                                                : null
                                                        } */}
                                                        <ErrorMessage name={`productDetails[${index}].productName`}>
                                                            {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                                                        </ErrorMessage>
                                                    </Table.Cell>
                                                    <Table.Cell width={2}>{object.hsnCode || object.sacCode ? `${object.hsnCode, object.sacCode}` : ''}</Table.Cell>
                                                    <Table.Cell style={{ minWidth: '80px' }}>
                                                        <Fieldmik
                                                            component={MyNormalInput}
                                                            type="number"
                                                            value={object.quantity === 0 ? '' : object.quantity}
                                                            min="1"
                                                            autoComplete="off"
                                                            name={`productDetails[${index}].quantity`}
                                                            size="small"
                                                        />
                                                        <ErrorMessage name={`productDetails[${index}].quantity`}>
                                                            {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                                                        </ErrorMessage>
                                                    </Table.Cell>

                                                    <Table.Cell style={{ minWidth: '90px' }}>
                                                        <Fieldmik
                                                            component={MyNormalInput}
                                                            type="number"
                                                            min="1"
                                                            value={object.rate === 0 ? 0 : object.rate}
                                                            autoComplete="off"
                                                            name={`productDetails[${index}].rate`}
                                                            size="small"
                                                        />
                                                        <ErrorMessage name={`productDetails[${index}].rate`}>
                                                            {error => <strong className="w3-text-red w3-tiny font-weight-bold">{error}</strong>}
                                                        </ErrorMessage>
                                                    </Table.Cell>
                                                    <Table.Cell style={{ minWidth: '124px' }}>
                                                        <Fieldmik style={{ width: '60%' }} type="number" component={MyNormalInput}
                                                            value={object.discount === 0 ? 0 : object.discount} name={`productDetails[${index}].discount`} size="small"
                                                            label={
                                                                <Dropdown placeholder={object.discountType === 2 ? '%' : "₹"}
                                                                    options={discountOptions}
                                                                    defaultValue={object.discountType}
                                                                    onChange={(value, data) => {
                                                                        object.discountType = data.value;
                                                                        valueChangeDiscount(object)
                                                                    }} />
                                                            }
                                                            labelPosition="right" className="tableinput" />
                                                    </Table.Cell>
                                                    <Table.Cell>{object.iGstPercent && isGstApplicable ? `${object.iGstPercent}%` : '0%'}</Table.Cell>
                                                    <Table.Cell>{object.iGst ? object.iGst.toFixed(2) : '0'}</Table.Cell>
                                                    <Table.Cell>{object.cGstPercent && isGstApplicable ? `${object.cGstPercent}%` : '0%'}</Table.Cell>
                                                    <Table.Cell>{object.cGst ? object.cGst.toFixed(2) : '0'}</Table.Cell>
                                                    <Table.Cell>{object.sGstPercent && isGstApplicable ? `${object.sGstPercent}%` : '0%'}</Table.Cell>
                                                    <Table.Cell>{object.sGst ? object.sGst.toFixed(2) : '0'}</Table.Cell>
                                                    <Table.Cell>{object.amount ? object.amount.toFixed(2) : '0'}</Table.Cell>
                                                    <Table.Cell hidden={index > 0 ? false : true} textAlign="right">
                                                        <Button onClick={() => remove(index)} type="button" basic size="mini" icon>
                                                            <Icon className="overhere" color="red" name="trash" />
                                                        </Button>
                                                    </Table.Cell>
                                                </React.Fragment>

                                            </Table.Row>
                                        )
                                    }
                                    )}
                                </Table.Body>
                            </Table>

                            <Grid columns={3}>
                                <Grid.Row className="p-2">
                                    <Grid.Column width={10}>
                                        <Button className="ml-2" type="button" onClick={() => push({ productName: '', startDate: '', endDate: '', quantity: '', rate: '', discount: '', discountType: '1', iGstPercent: '', iGst: '', cGstPercent: '', cGst: '', sGstPercent: '', sGst: '', amount: '' })} size="mini" basic color="blue">
                                            + Add Product
                                        </Button>
                                    </Grid.Column>
                                    <Grid.Column>
                                        {billmode ?
                                            <>
                                                <Grid.Row>
                                                    <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">New SO Total</Header>
                                                    <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.manualSoAddedTotal ? Number(values.manualSoAddedTotal).toFixed(2) : ""}</Header>
                                                </Grid.Row>
                                                <Grid.Row>
                                                    <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Active SO Total</Header>
                                                    <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.activeSoAddedTotal ? Number(values.activeSoAddedTotal).toFixed(2) : ""}</Header>
                                                </Grid.Row>
                                            </>
                                            :
                                            ""
                                        }
                                        <Grid.Row>
                                            <Header floated="right" as="label" className="labelName p-bold-600" size="tiny">Total</Header>
                                            <Header floated="right" as="label" className="labelName" size="tiny">₹ {values.finalAmount ? Number(values.finalAmount).toFixed(2) : ''}</Header>
                                        </Grid.Row>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>

                            <Modal onClose={() => setModalShow(false)} open={modalShow} size="tiny">
                                <Header closeButton>
                                    Product Details
                                </Header>
                                <Modal.Content>
                                    <table className="table">
                                        <thead className="thead-light">
                                            <tr>
                                                <th scope="col">Product Name</th>
                                                <th scope="col">Category Name</th>
                                                <th scope="col">GST Exempted</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                productDetail.map((item, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{item.product_name}</td>
                                                            <td>{item.product_category_name}</td>
                                                            <td>{item.is_gst_exempted == 0 ? 'No' : 'Yes'}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </Modal.Content>
                                <Modal.Actions>
                                    <Button className="w3-green" type='button' onClick={() => setModalShow(false)}>
                                        Close
                                    </Button>
                                </Modal.Actions>
                            </Modal>
                        </>
                    )
                }
                }
            </FieldArray>
        </div >
    )
}

export default AddProduct
